import { Component, OnInit } from '@angular/core';
import {
  FilterModel,
  TableData,
  TablesComponent,
} from '../../components/tables/tables.component';
import { CommonModule, DatePipe } from '@angular/common';
import {
  AdminReportFilterModel,
  ReportService,
} from '../../../core/services/report/report.service';

@Component({
  selector: 'app-patient-report-list',
  standalone: true,
  imports: [TablesComponent, CommonModule, DatePipe],
  templateUrl: './patient-report-list.component.html',
  styleUrl: './patient-report-list.component.scss',
  providers: [DatePipe],
})
export class PatientReportListComponent implements OnInit {
  maxDate: string;
  columns: string[] = [];
  filters: string[] = [];

  data: TableData[] = [];

  totalCount: number = 0;
  totalPage: number = 0;
  pageSize: number = 10;
  pageSizes = [10, 25, 50, 100];
  currentPage: number = 1;

  filterModel: AdminReportFilterModel = {
    customerCode: '',
    year: null,
    month: null,
  };

  constructor(private reportService: ReportService) {
    const today = new Date();
    this.maxDate = today.toISOString().split('T')[0];

    this.columns = ['customerCode', 'year', 'month', 'totalPatientCount'];
    this.filters = ['customerCode', 'year', 'month'];
  }
  ngOnInit(): void {
    this.getPatientReportList(this.currentPage, this.pageSize);
  }
  getPatientReportList(
    page: number,
    size: number,
    filters?: AdminReportFilterModel
  ): void {
    this.reportService.patientReportList(page, size, filters).subscribe({
      next: (res) => {
        this.data = res.items;
        this.totalCount = res.count;
        this.totalPage = res.pages;
        this.pageSize = res.size;
        this.currentPage = page;
      },
      error: () => {
        // this.toastMessage = 'Error occured while getting the user list.';
        // this.toastType = 'error';
      },
    });
  }
  onChangeFilterValues(e: FilterModel) {
    this.filterModel = {
      customerCode: e.customerCode,
      year: e.year,
      month: e.month,
    };
    this.getPatientReportList(1, this.pageSize, this.filterModel);
  }

  changePage(e: any): void {
    if (e.page > 0 && e.page <= this.totalPage) {
      this.getPatientReportList(e.page, e.pageSize, this.filterModel);
    }
  }
}
